import { render, staticRenderFns } from "./WikiMapPage.vue?vue&type=template&id=753d855c&"
import script from "./WikiMapPage.vue?vue&type=script&lang=ts&"
export * from "./WikiMapPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports